import { FIXED_POINT } from "../services/numbers";
import StakingItem from "../components/StakingItem";
import React, { useContext, useState } from "react";
import { PoolsContext } from "../config";
import appStore from "../store/app.store";

import { observer } from "mobx-react-lite";
import { collapsedReducer } from "../utils/reducers";
import { useAsync } from "../hooks";
import { getToken } from "../api";

import { Button, Footer } from "@airdao/ui-library";
import InfoBlock from "./Staking/components/InfoBlock";

import { ReactComponent as InfoIcon } from "../assets/svg/info-icon.svg";
import { ReactComponent as ChatHelpIcon } from "../assets/svg/chat-help-icon.svg";
import { ReactComponent as HBRIcon } from "../assets/svg/hbr.svg";
import { ReactComponent as ArrowIcon } from "../assets/svg/arrow-short.svg";
import background from "../assets/images/background.png";
import apy from "../assets/images/apy.png";

import { useAccount } from "wagmi";

const NewStaking = observer(() => {
  const { chainId } = useAccount();

  const [activeExpand, setActiveExpand] = useState(-1);
  const [state, dispatch] = React.useReducer(collapsedReducer, [false]);
  const pools = useContext(PoolsContext);

  const {
    data: courseData,
    status: priceStatus,
    run,
  } = useAsync({
    status: appStore.tokenPrice !== undefined ? "pending" : "idle",
    data: null,
  });

  React.useEffect(() => {
    if (priceStatus === "idle") {
      run(getToken());
    }
    if (priceStatus === "resolved") {
      appStore.setTokenPrice(courseData?.data?.price_usd);
      appStore.setTokenChange(courseData?.data?.percent_change_24h);
    }
  }, [run, priceStatus]);

  return (
    <>
      <img src={background} alt="background" className="background" />

      <section className="container staking__container">
        <div className="staking__content content">
          <h1 className="staking__heading">Stake and Earn</h1>
          <InfoBlock poolsArr={pools} />
          <div className="pools__content">
            <div className="pools__header pools__grid">
              <div className="pools__header-cell">Pools</div>
              <div className="pools__header-cell pools__cell-desktop-only">
                Currently staking
              </div>
              <div className="pools__header-cell">Total staked</div>
              <div className="pools__header-cell">APY</div>
            </div>
            {pools
              .filter(
                (pool) => pool.active || pool.totalStakeInAMB.gte(FIXED_POINT)
              )
              .sort((a, b) => b.active - a.active)
              .map((item, index) => (
                <StakingItem
                  dispatch={dispatch}
                  activeExpand={activeExpand}
                  setActiveExpand={setActiveExpand}
                  key={item.contractName}
                  index={index}
                  state={state}
                  expand
                  hasChain={+process.env.REACT_APP_CHAIN_ID === chainId}
                  comingSoon={!item.abi}
                  lazy
                  poolInfo={item}
                />
              ))}
            <div className="hbr">
              <div className="hbr__left">
                <HBRIcon/>
                <div>
                  <p className="hbr__title">Earn big with Harbour!</p>
                  <a href="https://star-fleet.io/harbor/liquid-staking/" target="_blank" className="hbr__link">
                    Start earning
                    <ArrowIcon/>
                  </a>
                </div>
              </div>
              <img src={apy} alt="35% apy" className="hbr__apy"/>
            </div>
          </div>
        </div>

      </section>

      <div className="guides-buttons container">
        <a
          href="https://airdao.io/academy#products-guides"
          target="_blank"
          rel="noreferrer nofollow"
        >
          <Button type="tetiary" size="large" leadIcon={<InfoIcon/>}>
            Guides
          </Button>
        </a>
        <a href="https://airdao.io/contact-us" target="_blank" rel="noreferrer">
          <Button type="tetiary" size="large" leadIcon={<ChatHelpIcon />}>
            Support
          </Button>
        </a>
      </div>

      <Footer />
    </>
  );
});

export default React.memo(NewStaking);
